// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_ao-0";
export var orangeButton = "_ao-1";